import i18n from '@/i18n/i18n'

export default {
  generate: (enumObj, localePrefixString) => {
    const elementArray = [];
    const i18nPrefix = localePrefixString;
    for (const value of Object.values(enumObj)) {
      const element = { id: value,
        name: i18n.t(localePrefixString + value),
        nameEn: i18n.t(localePrefixString + value, 'en'),
        nameFr: i18n.t(localePrefixString + value, 'fr')
      };
      elementArray.push(element);
    }
    enumObj.definition = elementArray;
    enumObj.getNameFor = function(x) {
      return i18n.t(i18nPrefix + x);
    };
    return enumObj;
  }
}